import React, { useEffect, useState } from "react";
import api from "../../api";

export default function ItemsForCatalogs({ offerHeaderId }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!offerHeaderId) return;

    const fetchProducts = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await api.get(
          `/store-offer/api/offers/${offerHeaderId}/products`,
          {
            headers: {
              Accept: "application/json",
            },
          }
        );

        setProducts(res.data || []);
      } catch (err) {
        setError("Failed to load products");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [offerHeaderId]);

  if (loading) return <p className="text-center">Loading products...</p>;
  if (error) return <p className="text-red-500 text-center">{error}</p>;

  return (
    <div className="h-full overflow-y-auto pr-2 ">
      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {products.map((item) => (
          <div
            key={item.productId}
            className="bg-white rounded-xl shadow-md p-4 hover:shadow-lg transition"
          >
            <h3 className="font-semibold text-gray-900 text-sm mb-1">
              {item.productName}
            </h3>

            <p className="text-xs text-gray-600">
              <span className="font-medium">Brand:</span>{" "}
              {item.brand?.brandName || "-"}
            </p>

            <p className="text-xs text-gray-500 mt-1">
              {item.categoryPath}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
